export default {
  setNotification (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setNotification", payload)
      resolve()
    })
  }
}
